import React from "react";
import PropTypes from "prop-types";
import Box from "../../../elements/box/Box";
import { Link } from "react-router-dom";
import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/outline";

function HasilKuisBox(props) {
  const {
    id,
    judul,
    keterangan,
    sifat,
    scoin,
    poin,
    status,
    tanggal_buka,
    tanggal_tutup,
    tipe,
    undang_count,
    data_responden_count,
    daftar_count,
  } = props.data ?? null;

  function buttonDetail(params) {
    if (tipe === 0) {
      return (
        <Link
          to={`/hasil-kuesioner/${props.data.id}`}
          className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
        >
          <p className="text-sm">Lihat Hasil</p>
        </Link>
      );
    } else if (tipe === 2) {
      return (
        <Link
          to={`/hasil-kuesioner/${props.data.id}`}
          className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
        >
          <p className="text-sm">Lihat Hasil</p>
        </Link>
      );
    } else {
        return (
          <Link
            to={`/hasil-kuesioner/${props.data.id}`}
            className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
          >
            <p className="text-sm">Lihat Hasil</p>
          </Link>
        );
    }
  }

  return (
    <div className="flex flex-row gap-4">
      <Box>
        <div className="flex flex-col">
          <div className="flex flex-row">
            <div className="w-11/12">
              <div className="flex flex-row items-center">
                {/* <UserCircleIcon className="h-10 w-10 m-2" /> */}
                <div className="flex-1 flex flex-col pr-4">
                  <h1 className="text-md font-bold">{id}</h1>
                  <div className="flex flex-row gap-2">
                    <p className="text-sm text-blue-500">
                      {tanggal_buka} {"<->"}
                    </p>
                    <p className="text-sm text-blue-500">{tanggal_tutup}</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-row items-center">
                <div className="flex-1 flex flex-col">
                  <h1 className="text-2xl font-bold">{judul}</h1>
                  <p>{keterangan}</p>
                  <div className="flex flex-row gap-4 mt-6">
                    <div className="flex flex-row items-center">
                      <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                        {tipe}
                      </span>
                      <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                        {sifat === "terbuka" ? (
                          <LockClosedIcon className="h-6 w-6" />
                        ) : (
                          <LockOpenIcon className="h-6 w-6" />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/12 flex flex-col gap-2 text-center">
              <span className="py-2 px-4 rounded bg-blue-100 dark:bg-blue-100 text-blue-600 dark:text-blue-900 font-bold text-sm">
                {poin} Poin
              </span>
              <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                {scoin} SC
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex flex-row justify-between">
              <div className="flex flex-row items-center gap-6">
                <p className="text-sm">Undangan: {undang_count}</p>
                <p className="text-sm">Pendaftar: {daftar_count}</p>
                <p className="text-sm">Responden: {data_responden_count}</p>
              </div>

              <div>
                <div className="flex justify-items-end">
                  {/* <Link
                    to={`/hasil-kuesioner/${props.data.id}`}
                    className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
                  >
                    <p className="text-sm">Lihat Hasil</p>
                  </Link> */}
                  <Link to={`/hasil-kuesioner/${props.data.id}`}>
                  <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border bg-blue-500 text-white">
                    <p className="text-sm">Hasil</p>
                  </button>
                </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
}

HasilKuisBox.propTypes = {
  data: PropTypes.object,
};

export default HasilKuisBox;
